export function communityOnOrbyt(name: string) {
  return `${name} on Orbyt`
}
